import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Componente per proteggere le rotte che richiedono autenticazione
// Accetta opzionalmente requiredRole (string) o allowedRoles (array)
const ProtectedRoute = ({ children, requiredRole = null, allowedRoles = null }) => {
  const { currentUser, loading } = useAuth();

  // Mostra un loader mentre verifichiamo lo stato di autenticazione
  if (loading) {
    return <div>Caricamento...</div>;
  }

  // Se l'utente non è autenticato, reindirizza al login
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Se sono specificati ruoli consentiti, verifica che l'utente ne abbia uno
  if (Array.isArray(allowedRoles) && allowedRoles.length > 0 && !allowedRoles.includes(currentUser.role)) {
    return <Navigate to="/dashboard" />;
  }

  // Se è richiesto un ruolo specifico e l'utente non ha quel ruolo, reindirizza alla dashboard
  if (requiredRole && currentUser.role !== requiredRole) {
    return <Navigate to="/dashboard" />;
  }

  // Se l'utente è al primo login, reindirizza alla pagina di cambio password
  if (currentUser.first_login && window.location.pathname !== '/change-password') {
    return <Navigate to="/change-password" />;
  }

  // Altrimenti, mostra il contenuto della rotta protetta
  return children;
};

export default ProtectedRoute;